import {FormGroup} from '@angular/forms';

export abstract class BaseValidationFrom<ControlFormInterface> {
    public form: FormGroup;
    public controls: ControlFormInterface;

    validateForm(messageFunction: (controlsLabel?: string) => { [key: string]: string }): boolean {
        if (this.form.invalid) {
            Object.keys(this.controls).forEach((key: string) => {
                const control = this.controls[key];
                const formControl = this.form.get(control.name);

                if (formControl && formControl.invalid) {
                    control.errors = Object.keys(formControl.errors).map((errorKey: string) => {
                        return messageFunction(control.placeholder)[errorKey];
                    });
                }
            });

            return false;
        }

        return true;
    }
}
